// API
const ENV = 'v1'
export const DOMAIN = process.env.API_ENDPOINT
export const LOGIN_API = DOMAIN + ENV + '/login'
export const REFRESH_TOKEN_API = DOMAIN + ENV + '/refresh'
export const USER_PROFILE_API = DOMAIN + ENV + '/myprofile'

export const CHANGE_PASSWORD_API = DOMAIN + ENV + '/password/change'
export const FORGOT_PASSWORD_API = DOMAIN + ENV + '/password/forgot'
export const RESET_PASSWORD_API = DOMAIN + ENV + '/password/reset'
export const USERS_LIST_API = DOMAIN + ENV + '/user'

export const GATES_LIST_API = DOMAIN + ENV + '/gate'
export const GATES_PASSAGE_API = DOMAIN + ENV + '/gate/passage'
export const RELATION_GATE_GROUP_API = DOMAIN + ENV + '/relation/gate-group'
export const GATE_MODEL_LIST_API = DOMAIN + ENV + '/gate/model'
export const PHONES_LIST_API = DOMAIN + ENV + '/phone'
export const MYLOGS_LIST_API = DOMAIN + ENV + '/mylogs'
export const PASSAGES_API = DOMAIN + ENV + '/passages'
export const GROUPS_LIST_API = DOMAIN + ENV + '/group'
export const GROUPS_PASSAGE_API = DOMAIN + ENV + '/group/passage'
export const PCODE_LIST_API = DOMAIN + ENV + '/pcode'
export const CONFIG_PCODE_TYPE_API = DOMAIN + ENV + '/config/pcode/type'
export const LOG_GATE_LIST_API = DOMAIN + ENV + '/log/gate'
export const LOG_OWNER_LIST_API = DOMAIN + ENV + '/log/owner'
export const OWNER_API = DOMAIN + ENV + '/owner'
export const CONFIG_LOG_API = DOMAIN + ENV + '/config/log'
export const KEY_SHARE_API = DOMAIN + ENV + '/key/share'
// ルータ
export const DASHBOARD_PATH = '/dashboard'
export const LOGIN_PATH = '/login'
export const KEY_ADD_PATH = '/key-add'
export const USER_PATH = '/users'
export const USER_ADD_PATH = 'users/add'
export const USER_IMPORT_PATH = 'users/import'
export const USER_EDIT_PATH = 'users/edit'
export const USER_PCODE_ADD_PATH = 'users/pcode-add'
export const USER_PASSAGE_ADD_PATH = 'users/passage-add'
export const USER_GATE_ADD_PATH = 'users/gate-add'
export const USER_CHANGE_PASSWORDPASS_PATH = '/change-password'
export const PCODE_PATH = '/pcode'
export const PCODE_ADD_PATH = '/pcode/add'
export const PCODE_EDIT_PATH = '/pcode/edit'
export const PCODE_IMPORT_PATH = '/pcode/import'
export const GROUP_PATH = '/groups'
export const GROUP_ADD_PATH = '/groups/add'
export const GROUP_IMPORT_PATH = 'groups/import'
export const GROUP_USER_IMPORT_PATH = 'groups/user-import'
export const GROUP_GATE_IMPORT_PATH = 'groups/gate-import'
export const GROUP_USER_ADD_PATH = '/groups/user-add'
export const GROUP_GATE_ADD_PATH = '/groups/gate-add'
export const GROUP_EDIT_PATH = '/groups/edit'
export const FORGOT_PASSWORD_PATH = '/forgot-password'
export const RESET_PASSWORD_PATH = '/reset-password'
export const LOG_PATH = '/logs'
export const GATE_PATH = '/gates'
export const GATE_ADD_PATH = '/gates/add'
export const GATE_GROUP_ADD_PATH = '/gates/group-add'
export const GATE_USER_ADD_PATH = '/gates/user-add'
export const GATE_EDIT_PATH = '/gates/edit'
export const GATE_IMPORT_PATH = '/gates/import'
export const PHONE_PATH = '/phones'
export const PHONE_IMPORT_PATH = 'phones/import'
export const PHONE_EDIT_PATH = '/phones/edit'
export const SETTING_PATH = '/setting'
export const CONFIG_LOG_EDIT_PATH = '/setting/configlog/edit'
export const EXPORT_PATH = '/export'
// メッセージ
export const LOGIN_API_ERROR = '事業者ID、ユーザーIDもしくはパスワードが間違っています。'
export const FORGOT_API_SUCCESS_SEND_RESET_CODE = 'リセットコードを送信しました。'
export const FORGOT_API_ERROR_SEND_RESET_CODE = '事業者ID、ユーザーIDの組み合わせが間違っています。'
export const RESET_API_SUCCESS_RESET_PASSWORD = 'パスワードがリセットされました。'
export const RESET_API_ERROR_RESET_PASSWORD = '事業者ID、ユーザーIDもしくはリセットコードが間違っています。'
export const SERVER_CONNECT_ERROR = 'システム管理者にお問い合わせください。'
export const CHANGE_PASSWORD_API_ERROR = '現在のパスワードが間違っています。'
export const CHANGE_PASSWORD_API_SUCCESS = 'パスワードが変更しました。'
export const ADD_USER_API_ERROR = 'エラーが起こりました。システム管理者にお問い合わせください。'
export const API_ERROR = 'エラーが起こりました。システム管理者にお問い合わせください。'
export const ADD_USER_API_SUCCESS = 'ユーザーが追加されました。'
export const ADD_GATE_API_SUCCESS = 'ゲートが追加されました。'
export const ADD_API_ERROR = 'エラーが起こりました。システム管理者にお問い合わせください。'
export const ADD_GROUP_API_SUCCESS = 'ゲートグループが追加されました。'
export const ADD_PCODE_API_SUCCESS = '個人コードが追加されました。'
export const EDIT_GROUP_API_SUCCESS = 'ゲートグループが編集されました。'
export const EDIT_GATE_API_SUCCESS = 'ゲートが編集されました。'
export const EDIT_PCODE_API_SUCCESS = '個人コードが編集されました。'
export const EDIT_USER_API_SUCCESS = 'ユーザーが編集されました。'
export const EDIT_SETTING_API_SUCCESS = '設定が編集されました。'
export const EDIT_PHONE_API_SUCCESS = 'スマートフォンが編集されました。'
export const DELETE_API_SUCCESS = '選択項目が削除されました。'
export const EDIT_CONFIG_LOG_API_SUCCESS = '照合ログが編集されました。'
export const DELETE_CONFIG_LOG_API_SUCCESS = '照合ログが初期化しました。'



// WEBPACK FOOTER //
// ./src/config.js